import { Component, Injectable, OnInit } from '@angular/core'

@Injectable()
@Component({
    selector: 'soaformagentexpired',
    templateUrl: 'soa-form-email-link-agent-expired.html',

})
export class SOAFormEmailLinkAgentExpiredComponent implements OnInit {


    ngOnInit() {

    }

}
